import FourHeadLogo from "../../assets/logos/fourhead-logo.svg";
import TelegramIcon from "../../assets/icons/telegram.svg";
import XIcon from "../../assets/icons/x.svg";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const navigationLinks = {
    row1: [
      { label: "Lobby", href: "/lobby" },
      { label: "Games", href: "/games" },
      { label: "Raffle", href: "/raffle" },
    ],
    row2: [
      { label: "Referrals", href: "/referrals" },
      { label: "Blog", href: "/blog" },
      { label: "Creator Program", href: "/creator-program" },
    ],
    row3: [
      { label: "Help & Support", href: "/help-support" },
      { label: "Privacy Policy", href: "/privacy-policy" },
    ],
  };

  const socialLinks = [
    {
      name: "Telegram",
      href: "",
      icon: <img src={TelegramIcon} alt="Telegram" width="20" height="20" />,
    },
    {
      name: "X (Twitter)",
      href: "",
      icon: <img src={XIcon} alt="X (Twitter)" width="20" height="20" />,
    },
  ];

  const renderNavRow = (links: typeof navigationLinks.row1) => (
    <div className="footer__nav-row">
      {links.map((link, index) => (
        <span key={link.label} className="footer__nav-item">
          <a href={link.href} className="footer__nav-link">
            {link.label}
          </a>
          {index < links.length - 1 && (
            <span className="footer__nav-separator"> / </span>
          )}
        </span>
      ))}
    </div>
  );

  return (
    <footer className="footer">
      <div className="footer__content">
        {/* Main Footer Content */}
        <div className="footer__main">
          {/* Logo and Navigation Links */}
          <div className="footer__brand">
            {/* Logo */}
            <div className="footer__logo">
              <img
                src={FourHeadLogo}
                alt="Fourhead Logo"
                className="footer__logo-image"
              />
            </div>

            {/* Navigation Links in rows with slashes */}
            <div className="footer__navigation">
              {renderNavRow(navigationLinks.row1)}
              {renderNavRow(navigationLinks.row2)}
              {renderNavRow(navigationLinks.row3)}
            </div>
          </div>

          {/* Socials Section */}
          <div className="footer__socials">
            <h3 className="footer__socials-title">SOCIALS</h3>

            {/* Social Icons */}
            <div className="footer__social-icons">
              {socialLinks.map((social) => (
                <a
                  key={social.name}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="footer__social-link"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>

            {/* Email Section */}
            <div className="footer__email-section">
              <h4 className="footer__email-title">EMAIL</h4>
              <a
                href="mailto:hello@fourhead.fun"
                className="footer__email-link"
              >
                hello@fourhead.fun
              </a>
            </div>
          </div>

          {/* Copyright Section */}
          <div className="footer__copyright-section">
            <p className="footer__copyright">© {currentYear} — Copyright</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
